import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type {
  SuggestedTopicsLoadAction,
  SuggestedTopicsLoadMoreAction,
} from '../../domains/suggestedTopics/actions.types';
import type { NormalizedSuggestedTopicsEntities } from '../../normalization/types';

import type { SuggestedTopics } from './types';

export const initialState: SuggestedTopics = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const loadSuggestedTopicsFulfilled = (entities: NormalizedSuggestedTopicsEntities) =>
  setFulfilled({
    topics: entities.suggestedTopics,
    pageInfo: entities.pageInfo,
  });

const loadMoreSuggestedTopicsFulfilled = (state: SuggestedTopics, entities: NormalizedSuggestedTopicsEntities) =>
  setFulfilled({
    topics: {
      ...state.fulfilled?.topics,
      ...entities.suggestedTopics,
    },
    pageInfo: entities.pageInfo,
  });

export type SuggestedTopicsAction = SuggestedTopicsLoadMoreAction | SuggestedTopicsLoadAction;

const reducer: Reducer<SuggestedTopics, SuggestedTopicsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SUGGESTED_TOPICS.LOAD_PENDING':
      return setPending();
    case 'SUGGESTED_TOPICS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    case 'SUGGESTED_TOPICS.LOAD_FULFILLED':
      return loadSuggestedTopicsFulfilled(action.payload.entities);
    case 'SUGGESTED_TOPICS.LOAD_MORE_FULFILLED':
      return loadMoreSuggestedTopicsFulfilled(state, action.payload.entities);
    default:
      return state;
  }
};

export default reducer;
